import React, { ReactNode } from 'react';

import { clientConfig } from '@/config/client';

import { TikTokIcon } from '../assets/TikTokIcon';
import { InstagramIcon } from '../assets/InstagramIcon';
import { FacebookIcon } from '../assets/FacebookIcon';
import { TelegramIcon } from '../assets/TelegramIcon';
import { YouTubeIcon } from '../assets/YouTubeIcon';

const { socialNetworksLinks } = clientConfig;

const socialIconMap: Record<string, () => ReactNode> = {
    TikTok: () => <TikTokIcon />,
    Instagram: () => <InstagramIcon />,
    Facebook: () => <FacebookIcon />,
    Telegram: () => <TelegramIcon />,
    YouTube: () => <YouTubeIcon />,
};

export const useSocials = () =>
    socialNetworksLinks.map(({ id, link }) => ({
        label: id,
        renderIcon: socialIconMap[id] ?? (() => null),
        link,
    }));
